import { render, staticRenderFns } from "./Disable2FA.vue?vue&type=template&id=50e0d543&scoped=true"
import script from "./Disable2FA.vue?vue&type=script&lang=js"
export * from "./Disable2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0d543",
  null
  
)

export default component.exports